import { service } from '@/utils/request'
const preApi = process.env.VUE_APP_ENV === 'development' ? '/dev' : ''
class materialDirection {
  // 获取素材风向标信息
  static getVaneInfo (params) {
    return service.get(`/api/vane/info`, { params })
  }
  // 获取素材风向标素材包信息
  static getPackageInfo (params) {
    return service.get(`${preApi}/vane/get_package_info`, { params })
  }
}

export default materialDirection
